import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from '@shared/services/auth.service';
import { PrivacyPolicyService } from '@shared/services/privacy-policy.service';
import { PocketbaseService } from '@shared/services/pocketbase.service';
import { HttpClient } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import PocketBase from 'pocketbase';

@Component({
  selector: 'app-privacy-update-modal',
  standalone: true,
  imports: [CommonModule, MarkdownModule],
  templateUrl: './privacy-update-modal.component.html',
  styleUrls: ['./privacy-update-modal.component.scss']
})
export class PrivacyUpdateModalComponent implements OnInit {
  isLoading = false;
  errorMessage = '';
  showFullPolicy = false;
  fullPolicyContent = '';

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private privacyPolicyService: PrivacyPolicyService,
    private pocketbaseService: PocketbaseService,
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    // Preload the full policy
    this.loadFullPolicy();
  }

  async loadFullPolicy(): Promise<void> {
    try {
      // Use an absolute path so this works on nested routes.
      const datenschutz = await this.http.get('/assets/datenschutzerklaerung.md', { responseType: 'text' }).toPromise() || '';
      const nutzung = await this.http.get('/assets/nutzungsbedingungen.md', { responseType: 'text' }).toPromise() || '';
      this.fullPolicyContent = nutzung + '\n\n---\n\n' + datenschutz;
    } catch (error) {
      console.error('Error loading legal documents:', error);
      this.fullPolicyContent = 'Fehler beim Laden der rechtlichen Dokumente.';
    }
  }

  showFullPrivacyPolicy(): void {
    this.showFullPolicy = true;
  }

  backToSummary(): void {
    this.showFullPolicy = false;
  }

  async acceptPrivacyUpdate(): Promise<void> {
    this.isLoading = true;
    this.errorMessage = '';

    try {
      const user = this.authService.user();
      if (!user) {
        throw new Error('Benutzer nicht authentifiziert');
      }

      // Get current privacy policy hash
      const currentHash = this.privacyPolicyService.getCurrentHash();

      if (!currentHash) {
        throw new Error('Konnte Datenschutzerklärung nicht validieren.');
      }

      // Update user record with current hash and acceptance date
      const pb = this.pocketbaseService.getPocketBase();

      await pb.collection('users').update(user.id, {
        privacy_policy_hash: currentHash,
        privacy_policy_accepted_date: new Date().toISOString()
      });

      // Refresh auth to get updated user data
      await this.authService.refreshAuth();

      // Close modal and clear privacy checking flag
      this.privacyPolicyService.closeModal();
      this.bsModalRef.hide();
    } catch (error: any) {
      console.error('Error accepting privacy update:', error);
      this.errorMessage = 'Fehler beim Speichern. Bitte versuche es erneut.';
    } finally {
      this.isLoading = false;
    }
  }

  decline(): void {
    // User declined - log them out and redirect to login
    this.authService.logout();
    this.privacyPolicyService.closeModal();
    this.bsModalRef.hide();
    this.router.navigate(['/auth/login']);
  }
}
